module.exports = __webpack_public_path__ + "img/Dekontaminieren.6c5fce34.svg";